import { Document } from './document';

export enum CampaignStatus {
    DRAFT = 'DRAFT',
    PENDING_APPROVAL = 'PENDING_APPROVAL',
    APPROVED = 'APPROVED',
    PARTIALLY_APPROVED = 'PARTIALLY_APPROVED',
    PENDING_REAPPROVAL = 'PENDING_REAPPROVAL',
    CANCELLED = 'CANCELLED',
    PAUSED_PENDING_SUP_APPROVALS = 'PAUSED_PENDING_SUP_APPROVALS',
    PAUSED = 'PAUSED',
    REJECTED = 'REJECTED',
    PARTIALLY_REJECTED = 'PARTIALLY_REJECTED',
    PARTIALLY_LIVE = 'PARTIALLY_LIVE',
    BEING_EDITED = 'BEING_EDITED',
    LIVE = 'LIVE',
    STOPPED = 'STOPPED',
    COMPLETED = 'COMPLETED'
}

export enum CampaignAction {
    EDIT = 'EDIT',
    DELETE = 'DELETE',
    PREVIEW = 'PREVIEW',
    CANCEL = 'CANCEL',
    PAUSE = 'PAUSE',
    RELAUNCH = 'RELAUNCH',
    ADD_CHARGES = 'ADD_CHARGES',
    RESTORE = 'RESTORE',
    STOP = 'STOP',
    APPROVE = 'APPROVE',
    REJECT = 'REJECT',
    PAUSE_VISUALS = 'PAUSE_VISUALS',
    DOWNLOAD_MEDIA = 'DOWNLOAD_MEDIA'
}

export enum CampaignLaunchMethod {
    GO_LIVE_WITH_APPROVED = 'GO_LIVE_WITH_APPROVED',
    AUTOMATICALLY_PAUSE_CAMPAIGN = 'AUTOMATICALLY_PAUSE_CAMPAIGN'
}

export class Campaign {
    title: string;
    brand: string;
    budget: number;
    status?: CampaignStatus;
    billingMethod: string;
    minChargeNeeded: boolean;
    capCPMNeeded: boolean;
    products?: any[];
    removedProducts?: any[];
    industryName?: string;
    numberOfVisuals: number;
    newNumberOfVisuals?: number;
    industryId?: number;
    channels?: Array<any>;
    channelsDetails?: any[];
    issuerName: string;
    issuerEmail: string;
    impressions?: number;
    campaignTotalPrice?: string;
    campaignNonCappedTotalPrice?: string;
    beingEdited: boolean;
    removedSupplier: boolean;
    startsIn2WorkingDays: boolean;
    version?: number;
    previousCampaignState?: Campaign;
    startDate: Date;
    supplierStatus?: any;
    relaunchStatus: CampaignStatus;
    endDate: Date;
    upcomingStatus: CampaignStatus;
    upcomingStatusDate: Date;
    _id?: string;
    wasPublished: boolean;
    /** Set by the server when the client accepted the Terms & Conditions; null if never accepted. */
    termsAcceptedAt: string;
    termsVersion: string;
    campaignDocuments: Document[];
    clientUpdatedAt?: Date;
    hasUnseenUpdates?: boolean;
    disclaimerMessage?: string;
    banners?: CampaignBanner[];
}

export interface CampaignBanner {
    type: string;
    message: string;
}
